import { useCallback, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { history } from 'lib/browserHistory'
import { useAppSelector } from 'redux/toolkit/hooks'

import routesConfig from 'lib/routesConfig'
import { useSupportRights } from 'components/libs/userRights/pages/useSupportRights'
import { SupportTopic } from 'types/Support'

export interface UseHelpLogic {
  brtsScan: boolean
  productName: string
  isCplAccount?: boolean
  componentInfo?: SupportTopic
  onSupportClick: () => void
  onGoBackClick: () => void
  onPrintableViewClick: () => void
}

export const useHelpLogic = (): UseHelpLogic => {
  const { pathname, key } = useLocation()
  const { accessTokenObject } = useAppSelector(_store => ({
    accessTokenObject: _store.auth.accessTokenObject
  }))
  const { accessibleTopics } = useSupportRights()

  const onSupportClick = useCallback(() => routesConfig.SUPPORT.goto(), [])
  const onPrintableViewClick = useCallback(() => window.open(`${pathname}?printable_view=true`, '_blank'), [pathname])
  const onGoBackClick = useCallback(() => (key !== 'default' ? history.back() : routesConfig.SUPPORT.goto()), [key])

  const componentInfo = useMemo(() => {
    let component
    for (let index = 0; index < accessibleTopics.length; index++) {
      const parent = accessibleTopics[index]
      component = parent.topics.find(child => child.href.path === pathname)
      if (component) {
        break
      }
    }

    return component
  }, [pathname, accessibleTopics])

  return useMemo(
    () => ({
      brtsScan: !window.location.hostname.startsWith('us'),
      productName: accessTokenObject?.isCplAccount ? 'cpl_product_name' : 'no_cpl_product_name',
      isCplAccount: accessTokenObject?.isCplAccount,
      componentInfo,
      onSupportClick,
      onGoBackClick,
      onPrintableViewClick
    }),
    [accessTokenObject, componentInfo, onSupportClick, onGoBackClick, onPrintableViewClick]
  )
}
